// Draw data-driven entities (software + GPU bridge via blitGame).

import type { World } from './world';
import { G } from './state';
import { S, TILE } from './constants';
import { screen, blitGame, DrawCircle } from '../render/surface';
import { getImg, getAssetScale } from '../render/assets';
import { isLegacyBehavior } from './entity-adapter';
import { getEnemyDef } from '../data/loader';

const tr = Math.trunc;

const SPRITE_MAP: Record<string, string> = {
  'enemies/wisp': 'dat/i/mons3.png',
};

let animTick = 0;

function resolveSprite(renderId: string): string {
  return SPRITE_MAP[renderId] ?? 'dat/i/mons3.png';
}

export function drawDataEntities(world: World): void {
  if (G.map_enabled) return;
  animTick++;

  for (const entity of world.entities.entities.values()) {
    if (entity.hp <= 0 || isLegacyBehavior(entity.behaviorId)) continue;
    if (entity.roomId !== G.player_room) continue;

    const sx = entity.pos.x - G.scroll_x;
    const sy = entity.pos.y - G.scroll_y;
    const defId = entity.data.defId as string | undefined;
    const def = defId ? getEnemyDef(defId) : undefined;
    const frames = def?.render.frames;
    const fps = def?.render.fps ?? 8;
    let frameIdx = 0;
    if (frames && frames.length > 0) {
      frameIdx = tr(animTick / (33 / fps)) % frames.length;
    }

    const datPath = resolveSprite(entity.renderId);
    try {
      const surf = getImg(datPath);
      const ns = getAssetScale(datPath);
      const cell = 32 * ns;
      blitGame(surf, { x: frameIdx * cell, y: 0, w: cell, h: cell }, screen, sx - S(8), sy - S(8), ns);
    } catch {
      DrawCircle(sx, sy, S(8), 200);
    }
  }
}
